import { createAction, props } from '@ngrx/store';

export const setDirectoryId = createAction('[App Data] Set DirectoryId', props<{ directoryId:string }>());
export const setAccessToken = createAction('[App Data] Set Access Token', props<{ token:string }>());
export const setUserName = createAction('[App Data] Set UserName', props<{ userName:string }>());
export const setImpersonation = createAction('[App Data] Set Impersonation', props<{ id:string, name:string }>());